export const environment = {
    version: '1.0.28',
    production: false,
    serviceWorkerEnabled: true,
    updateCheckInterval: 10 * 60 * 1000, // 10 minutes

    // API Configuration
    apiUrl: 'https://qa.api.americandronenetwork.com',
    webSocketUrl: 'wss://qa.api.americandronenetwork.com',

    appCDN: 'https://qa.cdn.americandronenetwork.com',
    // Brand assets (logos). Same host in every environment.
    staticCDN: 'https://static-cdn.americandronenetwork.com',

    // Compliance report recipients
    // Deliberately BLANK on staging — a staging test must never be able to one-click a real
    // report to the FAA. Blank renders an "address pending" notice and reveals the free-text
    // recipient input, so the flow stays fully testable with your own address.
    faaReportEmail: '',
    // ADN's DJI Regulatory Authority email, shown in the "connect a DJI drone" steps. Blank shows a
    // "contact support" notice instead; set the real address per environment once it is confirmed.
    djiRegulatoryAuthorityEmail: '',

    // Technical Support (Zoho Voice)
    technicalSupportPhone: '+18337371332',

    // Zoho Desk ASAP Widget
    zohoAsap: {
        enabled: true,
        scriptUrl: 'https://desk.zoho.com/portal/api/web/asapApp/1244338000000584054?orgId=910835565'
    },

    firebase: {
        apiKey: "AIzaSyCE0BJ9oFLQxOPvmgZCz4VrQcaBZm27Rc0",
        authDomain: "american-drone-network-qa.firebaseapp.com",
        projectId: "american-drone-network-qa",
        storageBucket: "american-drone-network-qa.firebasestorage.app",
        messagingSenderId: "171047914869",
        appId: "1:171047914869:web:d3b9d71647820cd438173c",
        measurementId: "G-NXL6K8LKWL",
        enableAnalytics: true
    }
};
